import styled from "styled-components";
export const Button = styled.button`
  display: inline-block;
  padding: 5px 20px;
  text-transform:uppercase;
  &:active,
  &:active:focus {
    outline: 0;
    background-image: none;
    -webkit-box-shadow: initial;
    box-shadow: initial;
  }

  &:focus {
    outline: initial;
    outline-offset: initial;
  }
`;
export const PrimaryButton = styled(Button)`
  border: var(--color-primary);
  background: var(--color-primary);
  color: white;
  &:hover{
    opacity: .91;
    border:var(--color-primary);
    color: white;
  }
`;

export const SecondButton = styled(Button)`
  border:var(--color-second);
  background:var(--color-second);
  color: white;
  &:hover{
    opacity: .91;
    border:var(--color-primary);
    color:var(--color-primary);
  }
`;

export const DefaultButton = styled(Button)`
  border:1px solid var(--color-primary);
  background:#fff;
  color: var(--color-primary);
`;
